import { render, staticRenderFns } from "./DeviceMonitoring.vue?vue&type=template&id=bd27b682&scoped=true&"
import script from "./DeviceMonitoring.vue?vue&type=script&lang=js&"
export * from "./DeviceMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMonitoring.vue?vue&type=style&index=0&id=bd27b682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd27b682",
  null
  
)

export default component.exports